"use client";
import React, { useState, useMemo, useEffect } from "react";
import { jobListings } from "./utils/jobs";
import location from "./assets/MapPinSimpleArea.svg";
import { Link } from "react-router-dom";
import { useJobs } from "./context/JobContext";

function Career() {
  const {
    jobListings,
    loading,
    currentPage,
    totalPages,
    setCurrentPage,
    goPrev,
    goNext,
    getPaginationNumbers,
  } = useJobs();

  const paginationNumbers = getPaginationNumbers();

  console.log( "jobListings", jobListings);

  return (
    <div className="relative min-h-screen w-full flex flex-col">
      {/* BACKGROUND GRADIENTS */}
      <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none ">
        {/* Top Gradient Row */}
        <div className="absolute top-[-250px] left-1/2 -translate-x-1/2 w-[1400px] flex justify-between">
          <div className="w-[612.5px] h-[612.5px] bg-[radial-gradient(50%_50%_at_50%_50%,rgba(39,196,133,0.24)_0%,rgba(233,242,252,0)_100%)]"></div>

          <div className="w-[612.5px] h-[612.5px] bg-[radial-gradient(50%_50%_at_50%_50%,#EBFCEA_0%,rgba(234,252,236,0)_100%)]"></div>
        </div>

        {/* Bottom Gradient Row */}
        <div className="absolute top-[300px] left-1/2 -translate-x-1/2 w-[1400px] flex justify-between">
          <div className="w-[612.5px] h-[612.5px] bg-[radial-gradient(50%_50%_at_50%_50%,#E9F2FC_0%,rgba(233,242,252,0)_100%)]"></div>

          <div className="w-[612.5px] h-[612.5px] bg-[radial-gradient(50%_50%_at_50%_50%,#EBFCEA_0%,rgba(234,252,236,0)_100%)]"></div>
        </div>
      </div>

      {/* PAGE TITLE */}
      <div className="w-full flex md:flex-col flex-col-reverse items-center justify-center px-4 mt-7 md:mt-20 gap-3 md:gap-6">
        <h2 className="md:text-center ml-10 md:ml-0 w-full max-w-[685px] h-8 md:text-[20px] text-[16px] text-[#656565] font-nunito font-bold leading-[32px]">
          Careers at HYNT
        </h2>

        <p className="md:text-center w-full px-4 font-oran font-normal md:text-[64px] text-[40px] leading-[64px]">
          Open positions
        </p>
      </div>

      {/* JOB LIST */}
      <div className="flex-1 max-w-[968px] mt-5 h-auto gap-2 mx-auto pb-6">
        {jobListings.map((job, index) => (
          <div key={job.jobId} className="w-full hidden md:block">
            <div className="max-w-[960px] relative flex items-center h-[64px] gap-6 rounded-[32px] py-2 px-4 mx-auto">
              <div className="w-[668px] flex justify-between h-[22px] items-center">
                <p className="font-nunito font-bold text-[16px] tracking-tighter text-[#808080]">
                  {job.title}
                </p>
                <p className="font-nunito font-bold text-[16px] tracking-tighter text-[#808080]">
                  {job.location}
                </p>
              </div>

              <Link
                to={`/careers/${job.jobId}`}
                className="w-[224px] h-[48px] flex justify-center items-center text-center border border-[#000000] rounded-[16px] pl-[12px]"
              >
                <p className="font-nunito font-medium text-[16px] tracking-tighter">
                  View
                </p>
              </Link>

              {index !== jobListings.length - 1 && (
                <div className="absolute w-full max-w-[900px] bottom-0 h-[0px] border-t border-[#E0E0E0] border-dashed border-[1px] [stroke-dasharray:2_2] mx-auto"></div>
              )}
            </div>
          </div>
        ))}

        {jobListings.map((job, index) => (
          <div className="w-full md:hidden relative h-auto rounded-[32px] flex flex-col gap-6 px-6 py-4">
            <div className="w-full flex flex-col gap-[8px]">
              <h2 className="font-nunito font-bold text-[16px] leading-[100%] tracking-[-0.41px] text-black">
                {job.title}
              </h2>
              <p className="font-nunito font-medium text-[16px] leading-[100%] tracking-[-0.41px] text-[#808080] flex items-center gap-2">
                <img src={location} alt="" className="w-4 h-4" />
                {job.location}
              </p>
            </div>

            <Link
              to={`/careers/${job.jobId}`}
              className="w-full ml-auto max-w-[128px] h-[48px] flex items-center justify-center gap-[8px] rounded-[16px] border border-black pl-[12px] pr-[16px] cursor-pointer"
            >
              <p className="font-nunito font-medium text-[16px] tracking-[-0.41px] text-black">
                View
              </p>
            </Link>
            <div className="absolute w-[97vw] bottom-0 h-[0px] border-t border-[#E0E0E0] border-dashed border-[1px] [stroke-dasharray:2_2] mx-auto"></div>
          </div>
        ))}
        {/* PAGINATION */}
        <div className="w-full px-4 flex items-center gap-[24px] justify-center md:justify-end mt-4 mb-5">
          {/* Left Button */}
          <button
            onClick={goPrev}
            disabled={currentPage === 1}
            className={`w-[48px] h-[48px] flex items-center justify-center ${
              currentPage === 1
                ? "bg-white text-[#E0E0E0] border-[#E0E0E0]"
                : "bg-[#000000] text-white"
            } rounded-[16px] border`}
          >
            <img src="/leftIcon.svg" alt="" className="w-5 h-5" />
          </button>

          {/* Page Numbers */}
          <div className="flex  gap-2">
            <p className="font-nunito font-medium text-[14px] tracking-[-0.41px]">
              Page {currentPage} of {totalPages}
            </p>

            <div className="flex items-center gap-2">
              {paginationNumbers.map((num, i) => {
                if (num === "...") {
                  return (
                    <p
                      key={i}
                      className="font-nunito md:text-[12px] text-[14px] leading-none text-black"
                    >
                      ...
                    </p>
                  );
                }

                return (
                  <button
                    key={i}
                    onClick={() => setCurrentPage(num)}
                    className={`w-[20px] h-[20px] rounded-[4px] flex items-center justify-center font-nunito font-medium md:text-[12px] text-[14px] leading-none
                      ${
                        num === currentPage
                          ? "bg-black text-white"
                          : "text-black"
                      }
                    `}
                  >
                    {num}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Right Button */}
          <button
            onClick={goNext}
            disabled={currentPage === totalPages}
            className={`w-[48px] h-[48px] flex items-center justify-center ${
              currentPage === totalPages
                ? "bg-white border-[#E0E0E0]"
                : "bg-[#000000] text-white"
            } rounded-[16px] border`}
          >
            <img
              src="/rightIcon.svg"
              alt=""
              className="w-5 h-5 text-[#E0E0E0]"
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Career;
